"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activeFlowSelector = activeFlowSelector;
exports.activeViewSelector = activeViewSelector;
exports.viewDataSelector = viewDataSelector;
function activeViewSelector(state) {
  return state.view.active;
}
function viewDataSelector(state) {
  return state.view.data;
}
function activeFlowSelector(state) {
  return state.activeFlow;
}